import loadable from '@loadable/component';
import config from '@wearetla/tla-essentials-tools/config';

// Functions
import checkUserAccess from '/functions/check-user-access';

// Data
import userAccess from '/data/user-access';

export default {
	home: {
		path: '/',
		exact: true,
		layout: 'base',
		layoutClass: 'home',
		forceSSR: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/home')),
	},
	login: {
		path: '/giris-yap',
		exact: true,
		layout: 'raw',
		layoutClass: 'login',
		head: {
			title: 'Giriş yapın',
		},
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/login')),
	},
	eventDetail: {
		path: '/etkinlik/:id/:slug/:calendarId?',
		exact: true,
		layout: 'base',
		layoutClass: 'event-detail',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/event-detail')),
	},
	customForm: {
		path: '/form/:id',
		exact: true,
		layout: 'base',
		layoutClass: 'custom-form',
		component: loadable(() => import('/views/pages/custom-form')),
	},
	payment: {
		path: '/bilet-satin-al/odeme',
		exact: true,
		layout: 'checkout',
		layoutClass: 'checkout-payment',
		checkoutStep: 2,
		layoutProps: {
			requiresLogin: true,
		},
		head: {
			title: 'Ödeme',
		},
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/checkout-payment')),
	},
	checkout: {
		path: '/bilet-satin-al/:id?/:calendarId?/:optionId?',
		exact: true,
		layout: 'checkout',
		layoutClass: 'checkout-ticketselection',
		checkoutStep: 1,
		layoutProps: {
			requiresLogin: false,
		},
		head: {
			title: 'Bilet Seçimi',
		},
		component: loadable(
			() => import(/* webpackPrefetch: true */ '/views/pages/checkout-ticketselection')
		),
	},
	checkoutSummary: {
		path: '/bilet-ozeti/:id',
		exact: true,
		layout: 'checkout',
		layoutClass: 'checkout-summary',
		checkoutStep: 3,
		layoutProps: {
			requiresLogin: true,
		},
		head: {
			title: 'Bilet Özeti',
		},
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/checkout-summary')),
	},
	faq: {
		path: '/sikca-sorulan-sorular/:slug?/:id?',
		exact: true,
		layout: 'base',
		layoutClass: 'faq',
		head: {
			title: 'Sıkça Sorulan Sorular',
		},
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/faq')),
	},
	page: {
		path: `/${config.brandInfo?.slug ?? 'sayfalar'}/:slug?/:id?`,
		exact: true,
		layout: 'base',
		layoutClass: 'page',
		head: {
			title: 'Sayfalar',
		},
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/page')),
	},
	contact: {
		path: '/iletisim',
		exact: true,
		layout: 'simple',
		layoutClass: 'contact',
		head: {
			title: 'İletişim',
		},
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/contact')),
	},
	menu: {
		path: '/menu/:slug?',
		exact: true,
		layout: 'base',
		layoutClass: 'menu',
		component: loadable(() => import('/views/pages/menu')),
	},
	walletInstructions: {
		path: '/cuzdanim/nasil-kullanirim',
		exact: true,
		layout: 'base',
		layoutClass: 'wallet-instructions',
		component: loadable(() => import('/views/pages/wallet-instructions')),
	},
	events: {
		path: '/etkinlikler',
		exact: true,
		layout: 'base',
		layoutClass: 'events',
		redirect: {
			key: 'eventsWithLocation',
			params: { location: 'tumu' },
		},
	},
	eventsWithLocation: {
		path: '/etkinlikler/:location/:query?',
		exact: true,
		layout: 'base',
		layoutClass: 'events',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/events')),
	},
	search: {
		path: '/arama/:term/:query?',
		exact: true,
		layout: 'base',
		layoutClass: 'events',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/search')),
	},
	account: {
		path: '/hesabim',
		requiresLogin: true,
		redirect: {
			key: 'account.info',
			params: {},
		},
		children: {
			info: {
				path: '/hesabim/bilgilerim',
				exact: true,
				layout: 'account',
				layoutClass: 'account-info',
				requiresLogin: true,
				head: {
					title: 'Bilgilerim',
				},
				component: loadable(() => import('/views/pages/account/info')),
				menuIcon: 'user',
			},
			bookings: {
				path: '/hesabim/biletlerim',
				exact: true,
				layout: 'account',
				layoutClass: 'account-bookings',
				requiresLogin: true,
				head: {
					title: 'Biletlerim',
				},
				component: loadable(() => import('/views/pages/account/bookings')),
				menuIcon: 'ticket',
			},
			wallet: {
				path: '/hesabim/cuzdanim',
				exact: true,
				layout: 'account',
				layoutClass: 'account-wallet',
				requiresLogin: true,
				head: {
					title: 'Cüzdanım',
				},
				component: loadable(() => import('/views/pages/account/wallet')),
				menuIcon: 'wallet',
			},
			addBalance: {
				path: '/hesabim/cuzdanim/bakiye-yukle',
				exact: true,
				layout: 'account',
				layoutClass: 'account-addbalance',
				requiresLogin: true,
				head: {
					title: 'Bakiye Yükle',
				},
				component: loadable(() => import('/views/pages/account/add-balance')),
				hideFromMenu: true,
			},
			merchantOrder: {
				path: '/hesabim/odeme-al',
				exact: true,
				layout: 'account',
				layoutClass: 'account-merchant-order',
				requiresLogin: true,
				head: {
					title: 'Ödeme Al',
				},
				component: loadable(() => import('/views/pages/account/merchant-order')),
				layoutProps: {
					accessCheck: ({ userRole }) => {
						return checkUserAccess(userRole, userAccess.merchantOrder);
					},
				},
				menuIcon: 'qr',
			},
			checkBooking: {
				path: '/hesabim/bilet-kontrol',
				exact: true,
				layout: 'account',
				layoutClass: 'account-check-booking',
				requiresLogin: true,
				head: {
					title: 'Bilet Kontrol',
				},
				component: loadable(() => import('/views/pages/account/check-booking')),
				layoutProps: {
					accessCheck: ({ userRole }) => {
						return checkUserAccess(userRole, userAccess.checkBooking);
					},
				},
				menuIcon: 'qr',
			},
			branchAnalytics: {
				path: '/hesabim/sube-raporlari',
				exact: true,
				layout: 'account',
				layoutClass: 'account-branch-reports',
				requiresLogin: true,
				head: {
					title: 'Şube Raporları',
				},
				component: loadable(() => import('/views/pages/account/branch-reports')),
				layoutProps: {
					accessCheck: ({ userRole }) => {
						return checkUserAccess(userRole, userAccess.branchAnalytics);
					},
				},
				menuIcon: 'coin',
			},
			userActions: {
				path: '/hesabim/kullanici-islemleri/:query?',
				exact: true,
				layout: 'account',
				layoutClass: 'account-user-actions',
				requiresLogin: true,
				head: {
					title: 'Kullanıcı İşlemleri'
				},
				component: loadable(() => import('/views/pages/account/user-actions')),
				layoutProps: {
					accessCheck: ({ userRole }) => {
						return checkUserAccess(userRole, [...userAccess.pairWallet, ...userAccess.userTransactions, ...userAccess.loadBalance_cash, ...userAccess.loadBalance_card]);
					},
				},
				menuIcon: 'user',
			},
			...(config.wallet?.enableNfcPayment ? {
				defineNfc: {
					path: '/hesabim/nfc-tanimla',
					exact: true,
					layout: 'account',
					layoutClass: 'account-define-nfc',
					requiresLogin: true,
					hideOnWeb: true,
					head: {
						title: 'NFC Kart Tanımla',
					},
					component: loadable(() => import('/views/pages/account/define-nfc')),
					layoutProps: {
						accessCheck: ({ userRole }) => {
							return checkUserAccess(userRole, userAccess.adminOnly);
						},
					},
					menuIcon: 'nfc',
				},
			} : {}),
		},
	},
	eventInfo: {
		path: '/etkinlik-hakkinda',
		redirect: {
			key: 'eventInfo.lineup',
			params: {},
		},
		children: {
			info: {
				path: '/etkinlik-hakkinda/bilmeniz-gerekenler',
				exact: true,
				layout: 'base',
				layoutClass: 'eventinfo-info',
				head: {
					title: 'Bilmeniz Gerekenler',
				},
				component: loadable(() => import('/views/pages/event-info/info')),
			},
			map: {
				path: '/etkinlik-hakkinda/etkinlik-haritasi',
				exact: true,
				layout: 'base',
				layoutClass: 'eventinfo-map',
				head: {
					title: 'Etkinlik Haritası',
				},
				component: loadable(() => import('/views/pages/event-info/map')),
			},
			lineup: {
				path: '/etkinlik-hakkinda/lineup',
				exact: true,
				layout: 'base',
				layoutClass: 'eventinfo-lineup',
				head: {
					title: 'Lineup',
				},
				component: loadable(() => import('/views/pages/event-info/lineup')),
			},
			workshops: {
				path: '/etkinlik-hakkinda/workshops',
				exact: true,
				layout: 'base',
				layoutClass: 'eventinfo-workshops',
				head: {
					title: 'Workshoplar',
				},
				component: loadable(() => import('/views/pages/event-info/workshops')),
			},
		},
	},
	notFound: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-not-found',
		status: 404,
		head: {
			title: 'Sayfa Bulunamadı',
		},
		component: loadable(() => import('/views/pages/not-found')),
	},
	error: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-error',
		status: 500,
		head: {
			title: 'Bir Hata İle Karşılaşıldı',
		},
		component: loadable(() => import('/views/pages/error')),
	},
};
